(function () {
    'use strict';

    /*
     UserContactController
    -------------------------------------------------------------------------- */

    angular
        .module('UserApp.contact', [])
        .controller('UserContactController', [
            '__Form',
            '$state',
            'appServices',
            '__Utils',
            '__Auth',
            '$scope',
            UserContactController
        ]);

    /**
      * UserContactController handle register form & send request to server
      * to submit form data. 
      *
      * @inject __Form
      * @inject $state
      * @inject appServices
      * 
      * @return void
      *-------------------------------------------------------- */

    function UserContactController(__Form, $state, appServices, __Utils, __Auth, $scope) {

        var scope = this;

        scope = __Form.setup(scope, 'user_contact_form', 'userData', {
            secured: true,
            unsecuredFields: ['message'],
        });

        // get logged in user Info
        __Auth.refresh(function (authInfo) {
            scope.auth_info = authInfo;
        });

        if (scope.auth_info.reaction_code != 9) { // not authenticate
            scope.userData.email = scope.auth_info.profile.email;
            scope.userData.fullName = scope.auth_info.profile.full_name;
        }

        if (!_.isEmpty($scope.ngDialogData)) {

            scope.userData.orderUID = $scope.ngDialogData.orderUID;
        }


        /**
          * Submit register form action
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.requestSuccess = false;

        scope.submit = function (formType) {

            scope.userData.formType = formType;

            __Form.process('user.contact.process', scope)
                .success(function (responseData) {

                    appServices.processResponse(responseData, null, function () {

                        scope.userData = '';

                        // Check if form type dialog or form
                        if (scope.userData.formType == 2) { // dialog

                            $scope.closeThisDialog();
                        } else {

                            $('.lw-form').slideUp();
                        }

                        scope.requestSuccess = true;

                    });

                });

        };

        /**
	  	  * Close dialog
	  	  *
	  	  * @return void
	  	  *---------------------------------------------------------------- */
        scope.closeDialog = function () {
            $scope.closeThisDialog();
        };

    };

})();